import React, { type ReactNode } from 'react'

interface FormSectionProps {
  title: string
  description: string
  children: ReactNode
}

export const FormSection: React.FC<FormSectionProps> = ({ title, description, children }) => (
  <section className='d-flex flex-column'>
    <h2 className='paragraph-large fw-600 zocks-text-gray-900 mb-0'>{title}</h2>
    <p className='paragraph-small zocks-text-gray-600 mb-0'>{description}</p>
    <div className='d-flex flex-column zocks-gap-0.75 mt-3'>{children}</div>
  </section>
)
